import { render } from "./Sv025.vue?vue&type=template&id=ebf12164&scoped=true"
import script from "./Sv025.vue?vue&type=script&lang=js"
export * from "./Sv025.vue?vue&type=script&lang=js"

import "./Sv025.vue?vue&type=style&index=0&id=ebf12164&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf12164"]])

export default __exports__